import { useEffect } from 'react';

const DEFAULT_IMAGE = 'https://www.rev-technology.com/images/logos/logo.png';

function setMeta(attrKey, attrValue, content) {
  if (!content) return;
  const selector = `meta[${attrKey}="${attrValue}"]`;
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrKey, attrValue);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

function setCanonical(url) {
  if (!url) return;
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

export default function useSeo(title, description, options = {}) {
  const {
    canonical,
    ogTitle,
    ogDescription,
    ogImage,
    ogType,
    twitterTitle,
    twitterDescription,
    twitterImage
  } = options;

  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta && description) {
      descriptionMeta.setAttribute('content', description);
    }

    const canonicalUrl = canonical || `${window.location.origin}${window.location.pathname}`;
    setCanonical(canonicalUrl);

    const resolvedOgTitle = ogTitle || title;
    const resolvedOgDescription = ogDescription || description;
    const resolvedOgImage = ogImage || DEFAULT_IMAGE;
    const resolvedTwitterTitle = twitterTitle || resolvedOgTitle;
    const resolvedTwitterDescription = twitterDescription || resolvedOgDescription;
    const resolvedTwitterImage = twitterImage || resolvedOgImage;

    setMeta('property', 'og:title', resolvedOgTitle);
    setMeta('property', 'og:description', resolvedOgDescription);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', resolvedOgImage);
    setMeta('property', 'og:type', ogType || 'website');

    setMeta('name', 'twitter:title', resolvedTwitterTitle);
    setMeta('name', 'twitter:description', resolvedTwitterDescription);
    setMeta('name', 'twitter:image', resolvedTwitterImage);
  }, [
    title,
    description,
    canonical,
    ogTitle,
    ogDescription,
    ogImage,
    ogType,
    twitterTitle,
    twitterDescription,
    twitterImage
  ]);
}
